var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "7ce02fd1-3d3c-4f1f-9392-b36b2db131a6"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "6891bf05-9dac-47cf-bc75-d84005d41c7b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(46.83 0 0 46.83 540 540)",
    id: "f21fdc48-d82f-4756-8903-778144b263f9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(112,101,240)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(112,101,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -12.03)",
    d: "M 12 4.595 C 10.896 3.5889999999999995 9.488 3.037 8.004 3.037 C 6.425999999999999 3.037 4.9319999999999995 3.66 3.7909999999999995 4.795 C 1.4379999999999993 7.1579999999999995 1.4389999999999996 10.854 3.7929999999999993 13.207 L 11.125 20.539 C 11.295 20.838 11.623 21.031000000000002 12 21.031000000000002 C 12.322 21.031000000000002 12.609 20.868000000000002 12.792 20.622000000000003 L 20.207 13.207000000000004 C 22.561 10.853000000000005 22.561 7.158000000000004 20.205000000000002 4.791000000000004 C 19.068 3.6600000000000037 17.574 3.037000000000004 15.996000000000002 3.037000000000004 C 14.513000000000002 3.037000000000004 13.104000000000003 3.589000000000004 12.000000000000002 4.595000000000004 z M 18.791 6.205 C 20.354 7.776 20.355 10.23 18.793 11.793 L 12 18.586 L 5.207 11.793 C 3.6449999999999996 10.229999999999999 3.646 7.775999999999999 5.205 6.209 C 5.965 5.452999999999999 6.959 5.037 8.004 5.037 C 9.049 5.037 10.039 5.453 10.793 6.207 L 11.293 6.707 C 11.684 7.098 12.315999999999999 7.098 12.706999999999999 6.707 L 13.206999999999999 6.207 C 14.719 4.698 17.281 4.702 18.790999999999997 6.205 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c33022e4898c1787b4ea1172441e28d7.svg";
export { ForwardRef as ReactComponent };